<mat-card class="cardWithShadow" style="margin: 0; height: 100%;overflow: hidden;border-radius: 0;">
  <mat-card-header class="w-100 d-block p-0" style="background-color: #1e293b;border-bottom: 3px solid #1e293b;">
    <mat-card-title>
      <div class="w-100 d-flex" style="background: #0f172a;">
        <span style="display: flex; align-items: center; margin-left: 15px; color: #27f309; font-size: 14px;">Signature électronique {{ esignLinkItem.DO_PIECE }}</span>
        <button class="m-l-auto" mat-icon-button (click)="matDialogRef.close();">
          <i-tabler name="x" class="icon-18" style="color: #27f309;"></i-tabler>
        </button>
      </div>
    </mat-card-title>
    <mat-card-subtitle style="color: black;background: white;" class="p-t-16 p-b-16">
      <div class="d-flex">
        <div class="d-flex flex">
          <div style="border-right: 2px solid black; margin-right: 15px;">
            <button mat-icon-button>
              <i-tabler name="check" class="icon-24 d-flex" style="color: #41bf32; align-items: center;"></i-tabler>
            </button>
          </div>
          <div class="d-grid">
            <span class="f-w-700"> Bienvenue {{ esignLinkItem.ESIGN_ESIGN_SF_NOM }} {{ esignLinkItem.ESIGN_ESIGN_SF_PRENOM }} </span>
            <span style="padding-top: 8px; font-size: 13px; color: #9b9b9f; font-weight: 600;">Signature électronique {{ esignLinkItem.DO_PIECE }} <span style="font-size: 11px; background-color: #7d0000; color: #ffffff; font-weight: 600; padding: 4px; border-radius: 4px; vertical-align: bottom;">EXP : {{ esignLinkItem.ESIGN_DATEEXP_UTC | date : 'dd/MM/yyyy HH:mm' }}UTC</span></span>
          </div>
        </div>
        <div class="m-l-auto">
        </div>
      </div>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-progress-bar *ngIf="showProgressBar" mode="indeterminate" color="primary"></mat-progress-bar>
  <mat-card-content style="flex: 1;padding: 0;overflow: auto;">
    <div class="m-t-8">
      <p *ngIf="esignLinkItem.ESIGN_S_MESSAGE" style="background: #c1e5ff; padding: 12px; font-weight: 700;text-align: center;margin-bottom: 0;">{{ esignLinkItem.ESIGN_S_MESSAGE }}</p>
    </div>
    <div ngForm #esignParamsForm="ngForm">
      <p style="font-size: 13px; font-weight: 700; background: #f6f5f9; padding: 8px;">Identité du signataire</p>
      <div class="row">
        <div class="flex flex-col col-md-12">
          <mat-form-field appearance="outline" class="w-100" color="primary">
            <mat-label>Genre</mat-label>
            <mat-select [(ngModel)]="esignParams.ESIGN_SF_GENRE" name="ESIGN_SF_GENRE" [maxlength]="1" required #ESIGN_SF_GENRE="ngModel">
                <mat-option [value]="0">H</mat-option>
                <mat-option [value]="1">F</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="flex flex-col col-md-12">
          <mat-form-field appearance="outline" class="w-100" color="primary">
            <mat-label>Nom</mat-label>
            <input matInput  matInput [autocomplete]="'off'" [(ngModel)]="esignParams.ESIGN_SF_NOM" name="ESIGN_SF_NOM" [maxlength]="30" required #ESIGN_SF_NOM="ngModel"/>
            <mat-hint *ngIf="ESIGN_SF_NOM.invalid && ESIGN_SF_NOM.touched" class="m-b-16 error-msg"> <div class="text-error" *ngIf="ESIGN_SF_NOM.errors?.['required']"> Le nom est requis </div> </mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
          <div class="flex flex-col col-md-12">
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <mat-label>Prénom</mat-label>
              <input matInput  matInput [autocomplete]="'off'" [(ngModel)]="esignParams.ESIGN_SF_PRENOM" name="ESIGN_SF_PRENOM" [maxlength]="30" required #ESIGN_SF_PRENOM="ngModel"/>
              <mat-hint *ngIf="ESIGN_SF_PRENOM.invalid && ESIGN_SF_PRENOM.touched" class="m-b-16 error-msg"> <div class="text-error" *ngIf="ESIGN_SF_PRENOM.errors?.['required']"> Le prénom est requis </div> </mat-hint>
            </mat-form-field>
          </div>
      </div>
      <div class="row">
          <div class="flex flex-col col-md-12">
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <mat-label>Message</mat-label>
              <textarea matInput [autocomplete]="'off'" [(ngModel)]="esignParams.ESIGN_SF_MESSAGE" name="ESIGN_SF_MESSAGE" [maxlength]="255" #ESIGN_SF_MESSAGE="ngModel" rows="3"></textarea>
            </mat-form-field>
          </div>
      </div>
      <div class="d-flex">
        <kendo-signature #signature [size]="'large'" [popupScale]="2" [rounded]="'medium'" [strokeWidth]="3" [fillMode]="'solid'" [strokeWidth]="1" [color]="'black'" [backgroundColor]="'transparent'" [(ngModel)]="esignParams.ESIGN_SF_SIGNATUREDATA" name="ESIGN_SF_SIGNATUREDATA" style="margin:auto; margin-bottom: 20px;"></kendo-signature>
      </div>
      <div class="row">
        <div style="display: flex; width: 100%; margin-left: 14px; margin-right: 15px; font-weight: 800; background: #f59d9d;">
          <p style="display: flex;"> <i-tabler name="point" class="icon-18 d-flex m-auto m-r-0 m-l-0"></i-tabler> <span style="margin-left: 10px;">Je reconnais avoir eu accès au document, l'avoir examiné, et accepte de le signer électroniquement conformément aux dispositions applicables.</span></p>
          <kendo-switch style="margin: auto; margin-right: 15px;transform: scale(0.8);" [(ngModel)]="confirmationChecked" name="confirmationChecked"></kendo-switch>
        </div>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions class="d-block m-0 p-0" style="background-color: #ffffff; border-top: 3px solid #1e293b;">
    <div class="d-flex w-100" style="padding-top: 6px;">
      <button mat-stroked-button [disabled]="showProgressBar" style="color: #707387; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1; margin-top: auto; margin-bottom: auto; height: 60px;" (click)="matDialogRef.close();"> ANNULER </button>
      <button mat-stroked-button [disabled]="showProgressBar || esignParamsForm.invalid == true || esignParamsForm.disabled == true || !confirmationChecked" style="color: #1bbaee; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1; height: 60px;" (click)="doRunDocumentESignProcessAction_PUPRemDocsESign();"> SIGNER </button>
    </div>
  </mat-card-actions>
</mat-card>